import { render, staticRenderFns } from "./MobileAppSupportedVersion.vue?vue&type=template&id=0da73056&scoped=true"
import script from "./MobileAppSupportedVersion.vue?vue&type=script&lang=js"
export * from "./MobileAppSupportedVersion.vue?vue&type=script&lang=js"
import style0 from "./MobileAppSupportedVersion.vue?vue&type=style&index=0&id=0da73056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da73056",
  null
  
)

export default component.exports